import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'photoSubNav',
  title: 'Photo Sub Nav',
  type: 'object',
  fields: [
    defineField({
      title: 'Nav Items',
      name: 'items',
      type: 'array',
      of: [{ type: 'photoNavItem' }],
    }),
  ],
})